import { convertGeometryToWkt, msg, react } from "../../../omnia"
import { TerramapContext } from "../../context"
import { ManagementTask, SelectionField } from "../../types"

import FormGroupSelectNumber = react.FormGroupSelectNumber
import Msg = react.Msg

interface Props {
    field: SelectionField
    tasks: ManagementTask[]
}

export function TrimLayers({ field, tasks }: Props) {

    const inProgress = tasks?.some(t => t.type === "trim-layers")

    return <div className="trim">
        {
            inProgress
                ? <TrimLayersInProgress />
                : <TrimLayersRequest field={field} />
        }

    </div>

}

function TrimLayersInProgress() {

    return <>
        <p>
            <i className="fas fa-cut" />&nbsp;Layers linked to this field are being reprocessed.
        </p>
    </>

}

function TrimLayersRequest({ field }: { field: SelectionField }) {

    const { api, dispatch } = React.useContext(TerramapContext)

    const [croppingId, setCroppingId] = React.useState(0)

    const cropping = field.field.cropping.filter(c => c.currentYear && c.boundary)
    const croppingOptions: [number, string][] = cropping.map(c => [c.croppingId, `${c.cropName} - (${c.area} ha)`])

    const selectedCropping = croppingId ? cropping.find(c => c.croppingId === croppingId) : undefined
    const hasSelection = !!selectedCropping

    const confirmation = () => <Msg>
        <p>
            All the Terramap layers associated with this field in this group will be trimmed to be boundary of the selected cropping
        </p>
        <p>
            This will be completed in the background, and cannot be reverted. Click 'Trim' to confirm.
        </p>
    </Msg>

    const trim = async () => {

        const title = "Trim layers"

        const ok = await react.showOkCancel(confirmation(), title, msg("Trim"))

        if (ok) {

            const newTasks = await api.trimLayers({
                fieldId: field.fieldId,
                croppingId,
                boundary: convertGeometryToWkt(selectedCropping.boundary),
                layerIds: field.layers.map(l => l.layerId)
            })

            dispatch({ type: "addMgmtTasks", newTasks })

        }

    }

    return <>

        <FormGroupSelectNumber
            className="trim"
            value={croppingId}
            setValue={setCroppingId}
            options={croppingOptions}
            defaultLabel="(Select the target cropping)"
            label=<>
                <i className="fas fa-cut" />&nbsp;
                Trim layers to this cropping boundary:
            </>

        />

        {

            hasSelection &&
            <div className="hint">
                {confirmation()}
            </div>

        }

        <div className="actions text-right">
            <button type="button" className="btn btn-success" disabled={!hasSelection} onClick={trim}>
                <i className="fas fa-cut" />&nbsp;Trim
            </button>
        </div>

    </>
}
